(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const skarpastMegaMenus = document.querySelectorAll('.skarpast-mega-nav__details');
  const skarpastFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const skarpastMegaMenuOpenDelay = 110;
  const skarpastMegaMenuCloseDelay = 240;
  const skarpastMegaMenuTimers = new WeakMap();

  const clearSkarpastMegaMenuTimer = (details, timerName) => {
    const timers = skarpastMegaMenuTimers.get(details);
    if (!timers?.[timerName]) return;

    window.clearTimeout(timers[timerName]);
    timers[timerName] = 0;
  };

  const setSkarpastMegaMenuTimer = (details, timerName, callback, delay) => {
    const timers = skarpastMegaMenuTimers.get(details) || { open: 0, close: 0 };
    clearSkarpastMegaMenuTimer(details, timerName);
    timers[timerName] = window.setTimeout(() => {
      timers[timerName] = 0;
      callback();
    }, delay);
    skarpastMegaMenuTimers.set(details, timers);
  };

  const closeOtherSkarpastMegaMenus = (activeDetails) => {
    skarpastMegaMenus.forEach((other) => {
      if (other === activeDetails) return;
      clearSkarpastMegaMenuTimer(other, 'open');
      clearSkarpastMegaMenuTimer(other, 'close');
      other.open = false;
    });
  };

  skarpastMegaMenus.forEach((details) => {
    skarpastMegaMenuTimers.set(details, { open: 0, close: 0 });

    details.addEventListener('toggle', () => {
      if (!details.open) return;
      closeOtherSkarpastMegaMenus(details);
    });

    details.addEventListener('pointerenter', () => {
      if (!skarpastFinePointer.matches) return;

      clearSkarpastMegaMenuTimer(details, 'close');
      if (details.open) return;

      setSkarpastMegaMenuTimer(
        details,
        'open',
        () => {
          closeOtherSkarpastMegaMenus(details);
          details.open = true;
        },
        skarpastMegaMenuOpenDelay
      );
    });

    details.addEventListener('pointerleave', () => {
      if (!skarpastFinePointer.matches) return;

      clearSkarpastMegaMenuTimer(details, 'open');
      if (!details.open) return;

      setSkarpastMegaMenuTimer(
        details,
        'close',
        () => {
          if (!details.matches(':hover, :focus-within')) details.open = false;
        },
        skarpastMegaMenuCloseDelay
      );
    });

    details.addEventListener('click', (event) => {
      if (!event.target.closest('summary')) return;
      clearSkarpastMegaMenuTimer(details, 'open');
      clearSkarpastMegaMenuTimer(details, 'close');
    });

    details.addEventListener('focusin', () => {
      clearSkarpastMegaMenuTimer(details, 'close');
    });

    details.addEventListener('focusout', () => {
      setSkarpastMegaMenuTimer(
        details,
        'close',
        () => {
          if (!details.matches(':hover, :focus-within')) details.open = false;
        },
        skarpastMegaMenuCloseDelay
      );
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        clearSkarpastMegaMenuTimer(details, 'open');
        clearSkarpastMegaMenuTimer(details, 'close');
        details.open = false;
        details.querySelector('summary')?.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
